import React, { useEffect, useRef, useState } from "react";
import { getVideos } from "../../../backend/video/video";
import { Video } from "../../../types/video/video";
import { useMediaQuery } from "react-responsive";
import { useLocation } from "react-router-dom";
import { addScrollRef, scrollToRef } from "../../../backend/scrollToRef";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "../Media/Media.scss";

const MainVideo = ({mainVideo}: { mainVideo: Video }) => {
  const isVertical = useMediaQuery({query: `(max-width: 900px)`});

  return (
    <a
      className="media__main-video"
      href={mainVideo.redirectLink}
      target="_blank"
    >
      <img
        src={mainVideo.imageLink.split("|")[0]}
        alt={
          mainVideo.imageLink.includes("|") ? mainVideo.imageLink.split("|")[1] : "Головне відео"
        }
        className="media__main-video-img"
      />
      <div className="media__main-video-info">
        <h3
          style={{
            fontSize: isVertical ? "min(2rem, 5vw)" : "min(2rem, 2vw)",
          }}
          className="media__main-video-title"
        >
          {mainVideo.name}
        </h3>

        {!isVertical && (
          <p
            style={{
              fontWeight: isVertical ? "bold" : "normal",
              fontSize: "16px",
              marginTop: "16px",
              transition: "all 0.3s ease",
            }}
          >
            {mainVideo.description}
          </p>
        )}
      </div>
    </a>
  );
};

const MoreVideoButton = () => {
  const [isHovering, setIsHovering] = useState(false);

  return (
    <div style={styles.videoBarContainer}>
      <a
        className="media__btn-more"
        style={{
          backgroundColor: isHovering ? "var(--black)" : "var(--orange)",
          color: !isHovering ? "var(--black)" : "var(--white)",
        }}
        href="https://www.youtube.com/@polk210"
        target="_blank"
        onMouseOver={(e) => setIsHovering(true)}
        onMouseOut={(e) => setIsHovering(false)}
      >
        <img
          src={
            isHovering
              ? "/assets/icons/social_media/yt-channel-w.svg"
              : "/assets/icons/social_media/yt-channel.svg"
          }
        />
        <p>ЩЕ ВІДЕО</p>
      </a>
    </div>
  );
};

const SideVideo = ({video}: { video: Video }) => {
  const isMedium = useMediaQuery({query: `(max-width: 700px)`});
  const isSmall = useMediaQuery({query: `(max-width: 450px)`});

  return (
    <div className="media__side-video-container">
      <a href={video.redirectLink} className="media__side-video">
        <img
          className="media__side-video-img"
          src={video.imageLink.split("|")[0]}
          alt={video.imageLink.includes("|") ? video.imageLink.split("|")[1] : "Відео"}
        />
        <h4
          className="media__side-video-title"
          style={{
            ...styles.sideVideoName,
            fontSize: isSmall ? "min(1rem, 5vw)" : isMedium ? "min(1rem, 5vw)" : "1.5rem",
          }}
        >
          {video.name}
        </h4>
      </a>
      <hr className="media__side-video-hr"/>
    </div>
  );
};

const Media = () => {
  const videos = getVideos();
  const isScrolling = useMediaQuery({query: `(max-width: 900px)`});

  const mediaRef = useRef(null);
  useEffect(() => {
    addScrollRef("media", mediaRef);
  }, [mediaRef]);

  const location = useLocation();
  useEffect(() => {
    if (location.state?.scrollTo === "media") {
      window.history.replaceState(null, "", window.location.href);
      scrollToRef(mediaRef);
    }
  }, [location]);

  const prevRef = useRef<HTMLDivElement>(null);
  const nextRef = useRef<HTMLDivElement>(null);

  return (
    <div
      ref={mediaRef}
      className="media-inner"
      style={{
        background: "url(assets/texture.avif)",
        backgroundSize: "20%",
    }}
    >
      <div
        className="media-wrapper"
        style={{
          ...styles.videosContainer,
          padding: isScrolling ? "2rem 0rem" : "4rem 0rem",
        }}
      >
        <h2 className="media__header">
          Відео про нас
        </h2>
        <MainVideo mainVideo={videos[0]}/>
        <div className="media">
          <Swiper
            modules={[Navigation]}
            spaceBetween={24}
            slidesPerView={isScrolling ? 1.5 : 3}
            navigation={{
              prevEl: prevRef.current,
              nextEl: nextRef.current,
            }}
            pagination={{
              dynamicBullets: true,
            }}
            onBeforeInit={(swiper) => {
              swiper.params.navigation.prevEl = prevRef.current;
              swiper.params.navigation.nextEl = nextRef.current;
            }}
            loop={true}
            style={{width: "100%"}}
          >
            {videos.slice(1).map((video: Video, i: React.Key) => (
              <SwiperSlide key={i}>
                <SideVideo video={video}/>
              </SwiperSlide>
            ))}
            <div className="swiper-button-wrapp">
              <div ref={prevRef} className="swiper-button-prev"></div>
              <div ref={nextRef} className="swiper-button-next"></div>
            </div>
          </Swiper>
          <MoreVideoButton/>
        </div>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  videosWrapper: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    backgroundColor: "var(--olive)"
  },
  videosContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    width: "var(--main-container-width)",
  },

  videoGrid: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  // mainVideoRow: {
  //   flexDirection: "column",
  //   gridTemplateColumns: "2fr 1fr",
  //   textDecoration: "none",
  //   color: "var(--black)",
  //   cursor: "pointer",
  // },
  // mainVideoInfoContainer: {
  //   display: "flex",
  //   flexDirection: "column",
  //   justifyContent: "space-between",
  // },
  // mainVideoName: {
  //   fontSize: "min(2rem, 2vw)",
  //   fontWeight: "bold",
  //   transition: "all 0.3s ease",
  // },
  // sideVideoRow: {
  //   display: "flex",
  //   flexDirection: "row",
  //   justifyContent: "space-between",
  //   transition: "all 0.5s ease",
  //   overflow: "scroll",
  //   right: "calc(calc(100vw - var(--main-container-width)) / 2)",
  //   padding: "0 calc(calc(100vw - var(--main-container-width)) / 2)",
  //   position: "relative",
  //   width: "100vw",
  // },
  // videoColumn: {
  //   display: "flex",
  //   flexDirection: "column",
  //   width: "32.5%",
  //   textDecoration: "none",
  //   flexShrink: "0",
  //   cursor: "pointer",
  // },
  // sideVideo: {
  //   objectFit: "scale-down",
  //   position: "absolute",
  //   left: 0,
  //   top: 0,
  //   width: "100%",
  //   height: "100%",
  //   transition: "all 0.3s ease",
  // },
  // sideVideoNameContainer: {
  //   display: "flex",
  //   flex: "1",
  //   alignItems: "center",
  //   justifyContent: "center",
  //   transition: "all 0.3s ease",
  // },
  // sideVideoName: {
  //   padding: "1rem 0rem",
  //   fontWeight: "bold",
  //   transition: "all 0.3s ease",
  // },
  // sideVideoLine: {
  //   width: "100%",
  //   height: "1px",
  //   transition: "all 0.3s ease",
  // },
  // sideVideoContainer: {
  //   display: "flex",
  //   alignItems: "center",
  //   justifyContent: "center",
  //   width: "100%",
  //   paddingTop: "calc(9 / 16 * 100%)",
  //   position: "relative",
  // },
  // mainVideoImageWrapper: {
  //   position: "relative",
  //   height: "100%",
  // },
  // mainVideoImage: {
  //   position: "relative",
  //   top: 0,
  //   left: 0,
  //   width: "100%",
  //   height: "100%",
  //   objectFit: "contain",
  //   transition: "all 0.3s ease",
  // },
  divider: {
    width: "100%",
    height: "1px",
    borderColor: "var(--dark-grey)",
    marginBottom: "0.5rem",
  },
  buttonRow: {
    marginTop: "auto",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  arrow: {
    height: "min(8rem,20vw)",
  },
  backArrow: {
    height: "min(8rem,20vw)",
    transform: "rotate(180deg)",
  },
  videoBarContainer: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    marginTop: "24px",
  },
  videoBar: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    transition: "all 0.3s",

    textDecoration: "none",
    padding: "15px 1.5rem",
    border: " 3px solid var(--black)",
    marginTop: "0.75rem",
    fontWeight: "bold",
    fontSize: "1.75rem",
    gap: "2rem",
  },
};

export default Media;
